export default "__VITE_ASSET__BJDe$4ZV__"